/**
 * État de la connexion, partagé par toute l'application.
 *
 * « horsLigne » : le poste n'a pas internet, ou le serveur ne répond plus
 * (coupure chez le fournisseur, serveur arrêté). Une vérification légère
 * (/api/public/sante) tourne alors toutes les 20 secondes ; au retour de la
 * connexion, les saisies en attente sont envoyées automatiquement.
 */
import { reactive } from 'vue'
import { API_BASE } from '@/api'

export const etat = reactive({
  horsLigne: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  depuis: null,
  enAttente: 0,
  enErreur: 0,
  envoiEnCours: false,
  derniereSynchro: null,
  referenceLe: null,
  copieAffichee: null, // date de la copie affichée à la place des données du serveur
})

const auxRetours = []
let minuterie = null

export function quandRetourConnexion(fn) {
  auxRetours.push(fn)
}

export function signalerHorsLigne() {
  if (!etat.horsLigne) {
    etat.horsLigne = true
    etat.depuis = new Date().toISOString()
  }
  demarrerVerification()
}

export function signalerEnLigne() {
  etat.copieAffichee = null
  if (!etat.horsLigne) return
  etat.horsLigne = false
  etat.depuis = null
  arreterVerification()
  auxRetours.forEach(fn => { try { fn() } catch (e) { /* rien */ } })
}

async function verifier() {
  if (typeof navigator !== 'undefined' && !navigator.onLine) return
  try {
    const ctrl = new AbortController()
    const t = setTimeout(() => ctrl.abort(), 8000)
    const r = await fetch(`${API_BASE}/api/public/sante`, { cache: 'no-store', signal: ctrl.signal })
    clearTimeout(t)
    // 200 : le serveur répond et peut enregistrer (503 = serveur en panne : on attend)
    if (r.ok) signalerEnLigne()
  } catch (e) {
    // toujours hors ligne
  }
}

function demarrerVerification() {
  if (!minuterie) minuterie = setInterval(verifier, 20000)
}

function arreterVerification() {
  clearInterval(minuterie)
  minuterie = null
}

if (typeof window !== 'undefined') {
  window.addEventListener('offline', signalerHorsLigne)
  window.addEventListener('online', verifier)
  if (!navigator.onLine) demarrerVerification()
}
